import { Component, computed, output, OutputEmitterRef, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IconButtonComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { AuthService } from '@libs/shared/auth';
import { CustomerModel } from '@libs/account/models';
import { DialogService, FlashMessageModule } from '@libs/shared/common';
import { firstValueFrom } from 'rxjs';
import { CustomerChangeComponent } from '../customer-change.component';

@Component({
  selector: 'ui-customer-change-bar',
  templateUrl: './customer-change-bar.component.html',
  styleUrls: ['./customer-change-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FlashMessageModule,
    MatDialogModule,
    IconButtonComponent,
    IconComponent,
  ],
})
export class CustomerChangeBarComponent {
  public customers: Signal<CustomerModel[] | undefined> = this.authService.allCustomers;
  public currentCustomer: Signal<CustomerModel | undefined> = this.authService.currentCustomer;
  public customersLength: Signal<number> = computed(() => this.customers()?.length ?? 0);

  public readonly customerSelected: OutputEmitterRef<CustomerModel> = output();

  private dialogRef?: MatDialogRef<CustomerChangeComponent, CustomerModel>;

  public constructor(
    private readonly authService: AuthService,
    public dialog: DialogService,
  ) {
  }

  public openDialog(): void {
    this.dialogRef = this.dialog.open(CustomerChangeComponent, {
      autoFocus: false,
      restoreFocus: false,
    });

    void firstValueFrom(this.dialogRef.afterClosed())
      .then(customer => {
        if (customer) {
          this.customerSelected.emit(customer);
        }
      });
  }
}
